const BANNER_VARIANTS = {
  HIGHLIGHT: 'highlight',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  PREMIUM: 'premium',
  PROMO: 'promo'
};

export { BANNER_VARIANTS };
